function initMediaGalleryCarousels(scope = document) {
  const carousels = scope.querySelectorAll('[id^="media-gallery-"]');

  carousels.forEach((carousel) => {
    if (!carousel.classList.contains('slick-initialized') && window.jQuery) {
      const $ = window.jQuery;

      const options = {
        arrows: carousel.dataset.arrows == 'true',
        lazyload: 'ondemand',
        dots: carousel.dataset.dots == 'true',
        infinite: carousel.dataset.infinite == 'true',
        autoplay: carousel.dataset.autoplay == 'true',
        autoplaySpeed: parseInt(carousel.dataset.autoplaySpeed || '3000', 10),
        slidesToShow: parseInt(carousel.dataset.slidesToShow || '3', 10),
        slidesToScroll: parseInt(carousel.dataset.slidesToScroll || '1', 10),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: parseInt(carousel.dataset.slidesToShowMobile || '1', 10),
              slidesToScroll: 1
            }
          }
        ]
      };

      // Prevent layout shift: hide carousel until Slick is initialized
      const galleryWrapper = carousel.closest('.media-gallery');
      if (galleryWrapper) {
        galleryWrapper.style.visibility = 'hidden';
      }

      // On slick init: reveal and mark as initialized
      $(carousel).on('init', function () {
        carousel.classList.add('slick-initialized');

        // Restore visibility to prevent FOUC / stacking bug
        if (galleryWrapper) {
          galleryWrapper.style.visibility = 'visible';
        }
      });

      $(carousel).slick(options);
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initMediaGalleryCarousels();
});

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    initMediaGalleryCarousels(event.target);
  });
}